import { Controller } from "@hotwired/stimulus";
import { showOverlay, hideOverlay } from "../utils/modals";

export default class extends Controller {
  overlay;

  static values = {
    persistent: Boolean
  };

  declare readonly persistentValue: boolean;

  initialize() {
    this.close = this.close.bind(this);
  }

  connect() {
    if (this.element.classList.contains("active")) {
      this.overlay = showOverlay();
      this.overlay.addEventListener("click", this.close);
    }
  }

  disconnect() {
    if (this.overlay) {
      this.overlay.removeEventListener("click", this.close);
      hideOverlay();
    }
  }

  close() {
    hideOverlay();
    this.element.parentElement?.removeAttribute("src");
    if (this.persistentValue) {
      this.element.classList.remove("active");
    } else {
      this.element.remove();
    }
  }

  open() {
    showOverlay();
    this.element.classList.add("active");
  }
}
